/* eslint-disable no-unreachable */
/* eslint-disable default-case */
import moment from 'moment';
import toast from 'react-hot-toast';

/* eslint-disable no-useless-escape */
function isValidEmail(email) {
	// console.log(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/.test(email));
	return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/.test(email);
}

const phoneRegExp = /^((\+92)?(0092)?(92)?(0)?)(3)([0-9]{9})$/;
const titleRegex = /^[a-zA-Z\d\s&-]{2,50}$/;
const shiftTitleRegex = /^[a-zA-Z\d\s\-()_.:&]{3,100}$/;
const ibanRegex = /^[a-zA-Z\d]{24}$/;
const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/;
const cnicRegex = /^[0-9]{5}-[0-9]{7}-[0-9]$/;
const dateRegex =
	/^(((0[13-9]|1[012])[-/]?(0[1-9]|[12][0-9]|30)|(0[13578]|1[02])[-/]?31|02[-/]?(0[1-9]|1[0-9]|2[0-8]))[-/]?[0-9]{4}|02[-/]?29[-/]?([0-9]{2}(([2468][048]|[02468][48])|[13579][26])|([13579][26]|[02468][048]|0[0-9]|1[0-6])00))$/;
const menuIconRegex = /^[a-z0-9_]{2,100}$/;
const menuOrderRegex = /^[0-9]{1,3}$/;
const apiEndpointRegex = /^[a-zA-Z0-9\/-]{3,50}$/;
const bankCodeRegex = /^[a-zA-Z0-9.-]{2,10}$/;
const allRegex = /.{2,}/;
const activityGroupDescRegex = /^.{2,299}$/;
const designationTitle = /^[a-zA-Z\s&-.]{2,100}$/;
const numberRegex = /^\d+$/;
const qualificationNameRegex = /^[a-zA-Z\s&-.]{2,50}$/;
const qualificationAbbrRegex = /^[a-zA-Z\s&-.]{1,15}$/;

const companyNameRegex = /^.{2,100}$/;

const businessUnitRegex = /^.{2,100}$/;

const locationRegex = /^.{2,254}$/;

const successNotify = (data) => toast.success(data);
const errorNotify = (data) => toast.error(data);

const easternTime = (date, time) => {
	let target = new Date(date + 'T' + time);
	//EST
	let offset = -4.0;
	let clientDate = target;
	let utc = clientDate.getTime() + clientDate.getTimezoneOffset() * 60000;
	let serverDate = new Date(utc + 3600000 * offset);
	let toTimeConvert = serverDate.toLocaleTimeString();
	return `${toTimeConvert === 'Invalid Date' ? '' : toTimeConvert}`;
};
const generateArrayOfYears = () => {
	var max = new Date().getFullYear();
	var min = max - 1;
	var years = [];
	for (var i = max; i >= min; i--) {
		years.push({
			id: i,
			description: i,
		});
	}
	return years;
};

const getMonthName = (month) => {
	switch (month) {
		case 1:
			return 'January';
			break;
		case 2:
			return 'February';
			break;
		case 3:
			return 'March';
			break;
		case 4:
			return 'April';
			break;
		case 5:
			return 'May';
			break;
		case 6:
			return 'June';
			break;
		case 7:
			return 'July';
			break;
		case 8:
			return 'August';
			break;
		case 9:
			return 'September';
			break;
		case 10:
			return 'October';
			break;
		case 11:
			return 'November';
			break;
		case 12:
			return 'December';
			break;
	}
	return 0;
};

const idExists = (obj, id) => {
	return obj.some(function (el) {
		return el.id === id;
	});
};
const generateArrayOfMonths = () => {
	var max = new Date().getMonth() + 1;
	var min = max - 1;
	var months = [];
	if (max === 1) {
		months.push(
			{
				id: max,
				description: getMonthName(max),
			},
			{
				id: 12,
				description: getMonthName(12),
			},
		);
	} else {
		for (var i = max; i >= min; i--) {
			months.push({
				id: i,
				description: getMonthName(i),
			});
		}
	}
	return months;
};

const generateArrayOfMonthYear = () => {
	const years = generateArrayOfYears();
	const months = generateArrayOfMonths();
	const newArr = [];
	let today = moment();
	// let lastYear = moment()
	// 	.subtract(1, 'year')
	// 	.isoWeek(today.isoWeek())
	// 	.isoWeekday(today.isoWeekday());
	let currYear = moment(today?._d).format('YYYY');
	// let prevYear = moment(lastYear?._d).format('YYYY');

	if (idExists(months, 12) && idExists(months, 1)) {
		for (let i = 0; i < 2; i++) {
			newArr.push({
				id: months[i]?.id,
				description: `${getMonthName(months[i]?.id)} ${years[i]?.id}`,
			});
		}
	} else {
		for (let i = 0; i < 2; i++) {
			newArr.push({
				id: months[i]?.id,
				description: `${getMonthName(months[i]?.id)} ${currYear}`,
			});
		}
	}

	// years.map((year) => {
	// 	months.map((month) => {
	// 		newArr.push({
	// 			dateId: `${month?.id} ${year?.id}`,
	// 			description: `${getMonthName(month?.id)} ${year?.id}`,
	// 		});
	// 		return null;
	// 	});
	// 	return null;
	// });

	return newArr;
};

function innerHTML(data) {
	return { __html: data };
}

export {
	isValidEmail,
	phoneRegExp,
	titleRegex,
	shiftTitleRegex,
	ibanRegex,
	emailRegex,
	cnicRegex,
	dateRegex,
	menuIconRegex,
	menuOrderRegex,
	designationTitle,
	numberRegex,
	apiEndpointRegex,
	bankCodeRegex,
	allRegex,
	activityGroupDescRegex,
	qualificationNameRegex,
	qualificationAbbrRegex,
	companyNameRegex,
	businessUnitRegex,
	locationRegex,
	getMonthName,
	easternTime,
	successNotify,
	errorNotify,
	innerHTML,
	generateArrayOfYears,
	generateArrayOfMonths,
	generateArrayOfMonthYear,
};
